const name = 'classroomScore';
const path = 'students/grades';

export default {
    uploadScore: {
        method: 'post',
        path: path
    }
}